import { Row, Col, Divider } from 'antd';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate as useHistory } from 'react-router-dom';

function CodificheTerritorialiUABox({ defaultSkip, queryString }) {
  const history = useHistory();

  useEffect(() => {
    if (defaultSkip) defaultSkip(true);
    if (queryString) queryString('');
    document.title = 'Codifiche territoriali per la PA e il Paese - SITUAS';
  });

  return (
    <main id="main-content" className={`pb-4 pt-3 pb-4 bs-docs-section clearfix`}>
      <button
        tabIndex="0"
        id="returnButton"
        aria-label='Torna indietro'
        onClick={() => {
          history(`/home`);
        }}>
        <ArrowLeftOutlined aria-label={null} />
        <span>Indietro</span>
      </button>

      <Row className="box">
        <Col xs={24}>
          <h2 className="title-main">Codifiche territoriali per la PA e il Paese</h2>
          <Divider className="blue-divider" />

          <div>
            L’Istat, per le attività di produzione e diffusione dell’informazione statistica, crea e
            mantiene aggiornate le classificazioni delle unità territoriali, raccoglie le
            denominazioni ufficiali e ad ognuna di esse assegna un codice identificativo.
            <br /> Il Sistema informativo territoriale delle unità amministrative e statistiche
            gestisce gli enti territoriali riconosciuti dall’ordinamento amministrativo del
            Regno d’Italia prima, e da quello costituzionale della Repubblica poi, nonché le aree
            statistiche di rilievo per le policy nazionali e/o europee.
            <br /> Le unità territoriali descritte sono definite genericamente con il termine Unità
            amministrativa (Ua) o Unità statistica (Us).
            <br /> Pertanto, il Sistema informativo consente di operare secondo molteplici intenti:
          </div>
          <div
            className={`d-flex mt-2 pt-2 codifiche`}
            style={{ columnGap: '15px', rowGap: '10px' }}>
            <div
              className="py-2 px-3 card d-flex flex-column">
              Presentare le liste delle unità territoriali vigenti alla data di interesse selezionata,
              corredata da caratteristiche e classificazioni.
              <div className="mt-auto">
                <Link className="box-linkto" to="/territorio">
                  Vai alla sezione Unità territoriali
                </Link>
              </div>
            </div>
            <div
              className="py-2 px-3 card d-flex flex-column">
              Presentare liste di unità per tipologia di variazioni occorse nel periodo (costituzioni,
              estinzioni, cambi denominazione, ecc.).
              <div className="mt-auto">
                <Link className="box-linkto" to="/variazioni">
                  Vai alla sezione Variazione Unità territoriali
                </Link>
              </div>
            </div>
            <div
              className="py-2 px-3 card d-flex flex-column">
              Ricostruire o confrontare le unità territoriali e le relative codifiche in virtù dei
              cambiamenti intervenuti nel tempo.
              <div className="mt-auto">
                <Link className="box-linkto" to="/ricostruzione-codici">
                  Vai alla sezione Ricostruzione codici statistici
                </Link>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
}
export default CodificheTerritorialiUABox;
